import React from "react";
import {
    Box,
    Card,
    CardContent,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Tooltip,
    Typography, withStyles,
} from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import InfoIcon from "@material-ui/icons/Info";
import NumberFormat from "react-number-format";
import { maskCurrency } from "../../../../utils/commonUtils";
import Assumptions from "../../../../pages/client/Estimation/V1/Components/Assumptions";
import GroupAssumptions from "./GroupAssumptions";
import { Info } from "@material-ui/icons";
import { Theme } from "@material-ui/core/styles";


const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: "#2f2f2f",
        maxWidth: "767px",
        minWidth: "100px",
        color: "#ffccc",
        lineHeight: "18px",
        fontWeight: "normal",
        padding: "15px",
        margin: "0",
        boxShadow: "0 0 15px 0px #8c8c8c",
    },
}))(Tooltip);
export default function GroupEstimationContact(props: any) {
    const {
        responseData,
        lifeTimeDeathBenefitSeeking,
    } = props;
    const { stress, common, illustration } = responseData;

    const contributionamount: number = stress && stress.contributionamount || 0;
    const contributionamountFiveYears: number = (stress && stress.contributionamount) * 5 || 0;
    let incomeageto: number = common && common.incomeageto || 0;
    let incomeagefrom: number = common && common.incomeagefrom || 0;
    let income: number = illustration && illustration.income || 0;
    let totalincome: number = illustration && illustration.totalincome || 0;
    let deathbenefitlessloanyear1 = illustration && illustration.data && illustration.data.deathbenefitlessloanyear1 || 0;
    let deathbenefitlessloanage90 = illustration && illustration.data && illustration.data.deathbenefitlessloanage90 || 0;

    const paymentFrequency = common && common.paymentfrequency || "Annual";
    let contributionAmount = common && common.contributionamount;
    //If Employer Remove that from total
    if (common && common.contributionamountemployer) {
        contributionAmount = contributionAmount - common.contributionamountemployer;
    }
    let contributionText: any = false;
    if (paymentFrequency === "Monthly") {
        contributionText = `Monthly Contribution: ${maskCurrency((contributionAmount / 12) + "")}`;
    }

    return (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>

                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" color="primary" align="center" component="strong" className="mb0 mt20 floatLeft w100">
                                    POTENTIAL BENEFITS & DISTRIBUTIONS
                                </Typography>
                                {contributionText ? <Typography variant="body1" component="strong"
                                                                className="mt20 mb0 floatLeft w100">
                                    {contributionText}
                                </Typography> : ""}
                                <Typography variant="body1" component="strong" className="mt30 mb20 floatLeft w100">
                                    Policy funding (
                                    <NumberFormat
                                            value={contributionamount}
                                            displayType={"text"}
                                            decimalScale={0}
                                            thousandSeparator={true}
                                            prefix={"$"} />
                                    &nbsp;x 5 years =&nbsp;
                                    <NumberFormat
                                            value={contributionamountFiveYears}
                                            displayType={"text"}
                                            decimalScale={0}
                                            thousandSeparator={true}
                                            prefix={"$"} />)
                                </Typography>
                                <Typography variant="caption" align="left" className="floatLeft w100 mb40">Your
                                    contributions are used to purchase death
                                    benefit protection that can provide cash in the event of a chronic or terminal
                                    illness. The excess funds have the potential to accumulate and grow over time, which
                                    can be used to help supplement your retirement.
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1" component="strong" className="mb15 floatLeft w100">
                                    Potential Benefits and distributions by age</Typography>
                                <Typography variant="caption" className="floatLeft mr30"><FiberManualRecordIcon
                                        className="colorYellow floatLeft"
                                        style={{ marginTop: "-4px" }} /> Protection</Typography>
                                {
                                        !lifeTimeDeathBenefitSeeking &&
                                        <Typography variant="caption" className="floatLeft"><FiberManualRecordIcon
                                                className="colorBlue floatLeft"
                                                style={{ marginTop: "-4px" }} /> Accumulation</Typography>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <Card className="benefitsCard bgLightGray mt40 mb20">
                                    <CardContent className="benefitsCardContent">
                                        <List>

                                            <ListItem disableGutters={true}>
                                                <ListItemAvatar>
                                                    <FiberManualRecordIcon
                                                            style={{ marginTop: "-23px", float: "left" }}
                                                            className="colorYellow" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                        primary="Potential Initial death benefit protection (net of loan)"
                                                        secondary="Access to living benefit riders" />
                                                <ListItemSecondaryAction>
                                                    <Typography variant="subtitle1" className="mb0 valueText">
                                                        <NumberFormat
                                                                value={deathbenefitlessloanyear1}
                                                                displayType={"text"}
                                                                decimalScale={0}
                                                                thousandSeparator={true} prefix={"$"}
                                                                renderText={value => <Box className="f18 floatLeft"
                                                                >{value}</Box>} />
                                                        <Tooltip
                                                                color="primary"
                                                                title="Initial death benefit" arrow>
                                                            <IconButton aria-label="Info">
                                                                <InfoIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Typography>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        </List>
                                    </CardContent>
                                </Card>
                                {
                                        !lifeTimeDeathBenefitSeeking &&
                                        <Card className="benefitsCard bgLightGray mt40 mb20">
                                            <CardContent className="benefitsCardContent">
                                                <List>
                                                    <ListItem disableGutters={true}>
                                                        <ListItemAvatar>
                                                            <></>
                                                        </ListItemAvatar>
                                                        <ListItemText primary={
                                                            <React.Fragment>
                                                                <Typography
                                                                        variant="body1"
                                                                        component="strong"
                                                                        className="mb0"
                                                                >
                                                                    Potential Tax Free Distributions Between
                                                                    Age {incomeagefrom} and {incomeageto}
                                                                </Typography>
                                                            </React.Fragment>
                                                        } />
                                                    </ListItem>
                                                    <ListItem disableGutters={true}>
                                                        <ListItemAvatar>
                                                            <FiberManualRecordIcon
                                                                    style={{ marginTop: "-23px", float: "left" }}
                                                                    className="colorBlue" />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                                primary="Potential tax-free distributions"
                                                                secondary="when using policy loans" />
                                                        <ListItemSecondaryAction>
                                                            <Typography variant="subtitle1" className="mb0 valueText">
                                                                <NumberFormat
                                                                        value={income}
                                                                        displayType={"text"}
                                                                        thousandSeparator={true} prefix={"$"}
                                                                        renderText={value => <Box
                                                                                className="f18 floatLeft">{value}</Box>} /> /
                                                                yr<Tooltip arrow
                                                                           color="primary"
                                                                           title="This is an estimation of policy distributions taken annually.">
                                                                <IconButton aria-label="Info">
                                                                    <InfoIcon />
                                                                </IconButton>
                                                            </Tooltip></Typography>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                </List>
                                            </CardContent>
                                        </Card>
                                }
                                <Card className="benefitsCard bgLightGray mt40 mb20">
                                    <CardContent className="benefitsCardContent">
                                        <List>
                                            <ListItem disableGutters={true}>
                                                <ListItemAvatar>
                                                    <></>
                                                </ListItemAvatar>
                                                <ListItemText primary={
                                                    <React.Fragment>
                                                        <Typography
                                                                variant="body1"
                                                                className="mb0"
                                                                component="strong"
                                                        >
                                                            Age {incomeageto} (based off ages set above)
                                                        </Typography>
                                                    </React.Fragment>
                                                } />
                                            </ListItem>
                                            {
                                                    !lifeTimeDeathBenefitSeeking &&
                                                    <ListItem disableGutters={true}>
                                                        <ListItemAvatar>
                                                            <FiberManualRecordIcon style={{ float: "left" }}
                                                                                   className="colorBlue" />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                                primary={`Potential Cumulative distributions taken from age ${incomeagefrom}-${incomeageto}`}
                                                        />
                                                        <ListItemSecondaryAction>
                                                            <Typography variant="subtitle1" className="mb0 valueText">
                                                                <NumberFormat
                                                                        value={totalincome}
                                                                        displayType={"text"}
                                                                        thousandSeparator={true} prefix={"$"}
                                                                        renderText={value => <Box
                                                                                className="f18 floatLeft"
                                                                        >{value}</Box>} />
                                                                <Tooltip
                                                                        arrow
                                                                        color="primary"
                                                                        title="This is the tota l amount of distributions taken through age 90.">
                                                                    <IconButton aria-label="Info">
                                                                        <InfoIcon />
                                                                    </IconButton>
                                                                </Tooltip></Typography>
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                            }
                                            <ListItem disableGutters={true}>
                                                <ListItemAvatar>
                                                    <FiberManualRecordIcon style={{ float: "left" }}
                                                                           className="colorYellow" />
                                                </ListItemAvatar>
                                                <ListItemText
                                                        primary="Potential Remaining death benefit for beneficiaries net of all loan repayments."
                                                />
                                                <ListItemSecondaryAction>
                                                    <Typography variant="subtitle1" className="mb0 valueText">
                                                        <NumberFormat
                                                                value={deathbenefitlessloanage90}
                                                                displayType={"text"}
                                                                decimalScale={0}
                                                                thousandSeparator={true} prefix={"$"}
                                                                renderText={value => <Box className="f18 floatLeft"
                                                                >{value}</Box>} />
                                                        <Tooltip
                                                                arrow
                                                                color="primary"
                                                                title="The amount paid to a beneficiary upon the death
                                                                of an insured person. Death benefits start out higher
                                                                depending on your age and health. The amount shown here
                                                                 is the remaining amount at age 90 after policy
                                                                 distributions.">
                                                            <IconButton aria-label="Info">
                                                                <InfoIcon />
                                                            </IconButton>
                                                        </Tooltip></Typography>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        </List>
                                    </CardContent>
                                </Card>

                                {
                                    <GroupAssumptions common={common} />
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
    );
}